import Vue from "vue";
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        isLogin: false
    },
    mutations: {
        isLoginReceive(state, isLogin) {
            state.isLogin = isLogin;
        },
    },
    //持久化插件
    plugins: [createPersistedState({
        storage: window.sessionStorage,
    })]
});
